import React from 'react';
import { formatWalkingTime } from './GuestMapSurface';
import { getVenueImage } from './venueImage';
import { VenueFavoriteButton } from './VenueFavoriteButton';

export function ClosestCarousel({ venues, userPosition, onVenueClick }) {
  if (!venues?.length) return null;
  return (
    <div data-testid="map-closest-carousel" style={{ margin: '6px 0 0' }}>
      <div style={{ display: 'flex', gap: 12, overflowX: 'auto', padding: '4px 16px 14px', scrollSnapType: 'x mandatory', WebkitOverflowScrolling: 'touch' }}>
        {venues.map((venue, idx) => {
          const image = getVenueImage(venue, idx);
          const walking = formatWalkingTime(userPosition, venue);
          return (
            <div
              key={venue.id}
              role="button"
              tabIndex={0}
              data-testid={`map-closest-card-${venue.id}`}
              onClick={() => onVenueClick?.(venue.id)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onVenueClick?.(venue.id);
                }
              }}
              style={{
                flex: '0 0 78%',
                maxWidth: 280,
                scrollSnapAlign: 'start',
                cursor: 'pointer',
              }}
            >
              <div style={{ position: 'relative', borderRadius: 22, overflow: 'hidden', boxShadow: '0 14px 28px rgba(20, 16, 50, 0.18)' }}>
                <img src={image} alt={venue.name} style={{ width: '100%', height: 170, objectFit: 'cover', display: 'block' }} />
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(10, 8, 30, 0.78) 100%)' }} />
                <div style={{ position: 'absolute', top: 10, left: 10, display: 'inline-flex', alignItems: 'center', gap: 5, padding: '6px 10px', borderRadius: 999, background: 'rgba(18,18,28,0.55)', color: '#FFFFFF', fontFamily: "'Inria Serif', serif", fontSize: 12, fontWeight: 700, backdropFilter: 'blur(6px)' }}>
                  {Number(venue.rating) > 0 ? `★ ${venue.rating}` : 'New'}
                </div>
                <div
                  style={{ position: 'absolute', top: 8, right: 8 }}
                  onClick={(event) => event.stopPropagation()}
                >
                  <VenueFavoriteButton venueId={venue.id} size="sm" testIdPrefix="map-closest-favorite" />
                </div>
                <div style={{ position: 'absolute', left: 12, right: 12, bottom: 10, color: '#FFFFFF' }}>
                  <p style={{ margin: 0, fontFamily: "'Inria Serif', serif", fontSize: 18, fontWeight: 700, lineHeight: 1.1, textShadow: '0 2px 8px rgba(0,0,0,0.4)' }}>{venue.name}</p>
                  <p style={{ margin: '4px 0 0', fontFamily: "'Inria Serif', serif", fontSize: 12.5, fontWeight: 600, opacity: 0.92, textTransform: 'capitalize' }}>
                    {venue.category}{walking ? ` · ${walking}` : ''}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
